import React, {Component, PropTypes} from "react";
import {connect} from 'react-redux'
import {Modal} from 'react-bootstrap';
import * as formService from "../services/formService";
import { toast } from 'react-toastify';
import {fetchConversionTable, fetchForms} from '../actions';

class FormStateGroup extends Component {
    static childContextTypes= {
        location: React.PropTypes.object
    }
    static contextTypes = {
        router: React.PropTypes.object
    }
    
    constructor(props) {
      super(props);
      this.state = {
          open: false,
          stateEditModal: false,
          formId: props.formId,
          formState: props.formState,
          formName: props.formName,
          selectedOption: props.formState,
      };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({...nextProps});
    }

    showModal() {
      this.setState({
          "stateEditModal": true
      })
    }
    hideModal() {
        this.setState({
            "stateEditModal": false
        })
    }
    onSaveState() {
      // converting state value to rest endpoint name 
      const STATE_ENDPOINTS = {
              'OPEN': 'open',
              'SENT_TO_CUSTOMER': 'sent-to-customer',
              'IN_PROGRESS': 'not allowed',
              'RETURNED_TO_VALMET': 'returned-to-valmet',
              'REVIEWED': 'not allowed'}
      const newState = STATE_ENDPOINTS[this.state.selectedOption];
      if (newState === "not allowed") {
        this.setState({
          "stateEditModal": false
        })
      } else {
        formService.saveFormState(this.state.formId, newState).then((json) => {        
          toast( () => (<div style={{background: "#fff" , color: "#000"}}>State changed.</div>));
          const {dispatch} = this.props
          dispatch(fetchForms())
          dispatch(fetchConversionTable())
          this.setState({
            "stateEditModal": false
          })
        })
      }
    }

    handleOptionChange = changeEvent => {
      this.setState({
        selectedOption: changeEvent.target.value
      });
    };

    render() {
        const {user} = this.props;
        const {formId} = this.state;
        return (
            <div key={"stategroup" + formId}>
                  {user.manager === true ? <button type="button" onClick= {() => this.showModal()} className="btn btn-link" aria-label="Left Align" title="Change State">
                    <span className="glyphicon glyphicon-pencil" style={{fontSize: "0.8em"}} aria-hidden="true"></span>
                  </button>:""}
                  <Modal show={this.state.stateEditModal} onHide={this.closeModal}>
                    <Modal.Body>
                        <h2 style={{textAlign: 'center'}}>Edit state of survey</h2>
                        <div>Survey Name: {this.state.formName}</div>
                        <div>Old state: {this.state.formState}</div>
                        <h3>New state:</h3>
                        <form>
                          <div className="form-check">
                            <label>
                              <input
                                type="radio"
                                value="OPEN"
                                checked={this.state.selectedOption === "OPEN"}
                                onChange={this.handleOptionChange}
                                style={{marginRight: "0.5em"}}
                              />
                              Open
                            </label>
                          </div>

                          <div className="form-check">
                            <label>
                              <input
                                type="radio"
                                value="SENT_TO_CUSTOMER"
                                checked={this.state.selectedOption === "SENT_TO_CUSTOMER"}
                                onChange={this.handleOptionChange}
                                style={{marginRight: "0.5em"}}
                              />
                              Sent to Customer
                            </label>
                          </div>

                          <div className="form-check">
                            <label>
                              <input
                                type="radio"
                                value="RETURNED_TO_VALMET"
                                checked={this.state.selectedOption === "RETURNED_TO_VALMET"}
                                onChange={this.handleOptionChange}
                                style={{marginRight: "0.5em"}}
                              />
                              Returned to Valmet
                            </label>
                          </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-comments" onClick={() => this.onSaveState()}>Save</button> <button className="btn btn-comments" onClick={() => this.hideModal()}>Cancel</button>
                    </Modal.Footer>
                </Modal>
            </div>
      );
    }
}


function mapStateToProps(state) {
    const {forms,form, user} = state
    const isFetching = forms.isFetching
    return {
        forms,
        formsList: forms.formsList,
        form,
        user: user.user,
        stateEditShowModal: forms.stateEditShowModal,
        stateEditFormId: form.stateEditFormId

    }
}

export default connect(mapStateToProps)(FormStateGroup)




// WEBPACK FOOTER //
// ./src/containers/FormStateGroup.js